export default [
  {
    path: '/main/schedule',
    meta: {
      tag: 'list_schedule',
      name: 'Agenda',
      breadcrumb: 'Agenda'
    },
    component: () => import(/* webpackChunkName: "schedulle-list" */ '@/views/main/Schedule.vue'),
    children: [
      {
        path: '',
        name: 'listschedules',
        meta: {
          tag: 'list_schedule',
          name: 'Agenda',
          menu: 'schedule'
        },
        component: () => import(/* webpackChunkName: "schedulle-list" */ '@/views/main/Schedule.vue')
      }
    ]
  }
]
